module.exports = __webpack_public_path__ + "static/media/img2-2.9927812c.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/cana/nutricheck_suelo/K/img2-2.png
// module id = 1330
// module chunks = 3